module.exports = __webpack_public_path__ + "img/Gr1.9a3b4456.png";